import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { TABLE_CELL_HOVER_BG_COLOR } from '@insurancemenu/imenu-components-lib/dist/components/tables/utils/constants';

const styles: ComponentStylesProps<boolean> = {
  tableRow: {
    boxSizing: 'border-box',
    transition: 'none',
    borderBottom: `1px solid ${colors.neutral[300]}`,
    '&:last-of-type': {
      borderBottom: 'none',
    },
    // Additional styles are included here to ensure that cells with their own background color also change color on hover.
    '&:hover td, &:hover td div[class^="inCellDivision"]': {
      backgroundColor: TABLE_CELL_HOVER_BG_COLOR,
      transition: 'none',
    },
  },
  selectedRow: {
    border: `0.2rem solid ${colors.blue[600]}`,
    borderLeftWidth: '1rem',
    backgroundColor: TABLE_CELL_HOVER_BG_COLOR,
    '& td, td div[class^="inCellDivision"]': {
      backgroundColor: TABLE_CELL_HOVER_BG_COLOR,
    },
  },
  tableCell: (hasSelectedPeriodInGroup) => ({
    backgroundColor: hasSelectedPeriodInGroup ? TABLE_CELL_HOVER_BG_COLOR : colors.neutral.white,
    font: { size: '1.6rem', lineHeight: '2.4rem' },
    color: colors.neutral[900],
    letterSpacing: '0.02rem',
    padding: 0,
    '&:first-child': {
      padding: hasSelectedPeriodInGroup ? '1.6rem 1rem 1.6rem 1.4rem' : '1.6rem 1rem 1.6rem 2.4rem',
    },
    '&:nth-child(2)': {
      padding: '1.6rem 0',
    },
    '&:nth-child(3)': {
      '& > div': {
        paddingLeft: '1rem',
      },
    },
  }),
  emailDivisionCell: {
    minHeight: '3.962rem',
    '&:last-of-type': {
      minHeight: '2.399rem',
    },
  },
  customInCellBlock: {
    paddingBottom: '1.6rem',
    // backgroundColor: colors.neutral.white,
    margin: 0,
    paddingTop: '1.6rem',
    // To keep current style
    '&:last-child': {
      paddingBottom: '1.6rem',
    },
  },
  selectedCellBlock: {
    backgroundColor: colors.blue[100],
  },
  statuses: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  status: {
    height: '2.23rem',
    '&:not(:last-child)': {
      marginRight: '1rem',
    },
  },
  statusesList: {
    minHeight: '2.3994rem',
    display: 'flex',
  },
  actionBlock: {
    minHeight: '2.3994rem',
    height: '2.3994rem',
    display: 'flex',
    alignItems: 'center',
    gap: '3rem',
  },
  tooltipContent: {
    gap: '0.5rem',
    display: 'flex',
    alignItems: 'center',
  },
  checkboxWrapper: {
    '& label': {
      cursor: 'pointer',
    },
    '& svg': {
      width: '2.4rem',
    },
  },
  productLineCellContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
